const blobParsablefileExtensionsList = ["pdf"];

const isJsonParsable = (contentType) => {
    let isParsable = false;
    if (contentType && contentType.match("application/json"))
        isParsable = true;
    return isParsable;
}

const isBlobParsable = (contentType) => {
    let isParsable = false;
    if (contentType) {
        blobParsablefileExtensionsList.forEach(fileExtension => {
            if (contentType.match("application/" + fileExtension))
                isParsable = true;
        });
    }
    return isParsable;
}

export const parseFetchResponse = (response) => {
    if (response) {
        const contentType = response.headers.get("content-type");

        let parserResult = null;
        if (isJsonParsable(contentType))
            parserResult = response.json();
        else if (isBlobParsable(contentType))
            parserResult = response.blob();
        else
            parserResult = response.text();

        return response.ok ? parserResult : parserResult.then(error => Promise.reject(error));
    }
    return Promise.reject({ errorCode: 0, errorMessage: "error: response is null" });
}
